document.addEventListener('DOMContentLoaded', function () {
  var track = document.getElementById('Slider-photodudebut');
  var dots = Array.prototype.slice.call(document.querySelectorAll('.photodudebut-carousel__dot'));
  if (!track || !dots.length) return;

  var slides = Array.prototype.slice.call(track.querySelectorAll('.photodudebut-carousel__slide'));

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var target = document.getElementById(dot.getAttribute('data-target'));
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    });
  });

  var setActiveDot = function (index) {
    dots.forEach(function (dot, i) {
      var isActive = i === index;
      dot.classList.toggle('is-active', isActive);
      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  };

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var index = slides.indexOf(entry.target);
        if (index > -1) setActiveDot(index);
      });
    },
    { root: track, threshold: 0.6 }
  );

  slides.forEach(function (slide) {
    observer.observe(slide);
  });
});
